import { render, staticRenderFns } from "./GestionTarjeta.vue?vue&type=template&id=860a26a8&"
import script from "./GestionTarjeta.vue?vue&type=script&lang=js&"
export * from "./GestionTarjeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports